<template>
  <form>
    <b-alert
      v-if="findError('invitations')"
      show
      variant="danger"
      class="mt-4">
      {{ findError('invitations') }}
    </b-alert>
    <data-table
      :columns="invitationsColumns"
      :value="value.invitations"
      empty-message="Nessun invito trovato"
      row-class="row align-items-center pb-0"
      alert-class="mt-4"
    />
    <div class="text-right" v-if="!disabled">
      <b-button variant="success" @click.prevent="addInvitation">
        <i class="fa fa-fw fa-plus"></i> Aggiungi
      </b-button>
    </div>
  </form>
</template>
<script>
import EntityEditorMixin from 'vue-core/mixins/EntityEditorMixin';
import * as moment from 'moment';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

export default {
  mixins: [ EntityEditorMixin ],

  created() {
    this.invitationsColumns = [
      {
        type: 'component',
        component: 'string-form-field',
        //class: () => this.disabled ? 'col-9' : 'col-8',
        class: () => this.disabled ? 'col-md-9 mb-2' : 'col-md-9 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'userEmail', label: 'E-mail' }),
        events: this.columnEvents({ prop: 'invitations', key: 'userEmail' }),
      },
      {
        type: 'component',
        component: 'date-form-field',
        class: () => this.disabled ? 'col-md-3 mb-2' : 'col-md-3 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'expiration', label: 'Scadenza invito' }),
        events: this.columnEvents({ prop: 'invitations', key: 'expiration' }),
      },
      {
        class: 'col-md-12',
        type: 'actions',
        show: !this.disabled,
        actions: (item, index) => [
          {
            label: 'Rimuovi invito',
            //icon: 'times',
            buttonClass: 'bg-danger w-100 text-center mb-2',
            //buttonClass: 'text-danger pl-0',
            exec: () => this.removeInvitation(index)
          }
        ]
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permLoad', label: 'Visualizza analisi principale' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permLoad' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permUpdate', label: 'Modifica analisi principale' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permUpdate' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permReadMessages', label: 'Leggi messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permReadMessages' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permSendMessages', label: 'Invia messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permSendMessages' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permReceiveMessages', label: 'Ricevi notifiche messaggi' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permReceiveMessages' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permViewFiles', label: 'Visualizza file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permViewFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permViewFilesWithNoTags', label: 'Visualizza file SENZA TAG' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permViewFilesWithNoTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permUploadFiles', label: 'Carica file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permUploadFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permRenameFiles', label: 'Rinomina file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permRenameFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permAddFileTags', label: 'Aggiungi tag a file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permAddFileTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permRemoveFileTags', label: 'Rimuovi tag da file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permRemoveFileTags' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permDeleteFiles', label: 'Elimina file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permDeleteFiles' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permReceiveFiles', label: 'Ricevi notifiche file' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permReceiveFiles' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permLoadXbrlAnalysis', label: 'Visualizza analisi bilancio' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permLoadXbrlAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permUpdateXbrlAnalysis', label: 'Modifica analisi bilancio' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permUpdateXbrlAnalysis' }),
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permLoadCrAnalysis', label: 'Visualizza analisi CR' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permLoadCrAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permUpdateCrAnalysis', label: 'Modifica analisi CR' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permUpdateCrAnalysis' }),
      },

      {
        type: 'component',
        component: 'boolean-form-field',
        //class: () => this.disabled ? 'col-6 mb-0' : 'col-5 mb-0 offset-1',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permLoadCrifAnalysis', label: 'Visualizza analisi CRIF' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permLoadCrifAnalysis' }),
      },
      {
        type: 'component',
        component: 'boolean-form-field',
        class: 'col-md-6 mb-0',
        props: this.columnProps({ prop: 'invitations', key: 'permUpdateCrifAnalysis', label: 'Modifica analisi CRIF' }, { inline: true }),
        events: this.columnEvents({ prop: 'invitations', key: 'permUpdateCrifAnalysis' }),
      },

      {
        type: 'component',
        component: 'div',
        class: () => 'w-100 border-bottom my-2',
      },

      {
        type: 'component',
        component: 'tag-form-field',
        class: () => this.disabled ? 'col-12' : 'col-11',
        props: (item, index) => ({
          label: 'Tag permessi',
          value: item.tags.map(x => x.tag),
          dropdown: false,
          multiple: true,
          disabled: this.disabled,
          parameters: {
            nwi: true,
            workgroupIds: this.value.workgroup ? [this.value.workgroup.id] : null
          },
          error: this.findError('invitations[' + index + '].tags')
        }),
        events: (item, index) => ({
          input: (v) => {
            this.tagsSelected(item, index, v);
          }
        })
      },

      {
        type: 'component',
        component: 'div',
        show: (item, index) => (index !== this.value.invitations.length - 1),
        class: 'col content-separator mx-0',
      },
    ];
  },

  methods: {
    addInvitation() {
      const newValue = {
        userEmail: null,
        permLoad: true,
        permUpdate: false,
        permReadMessages: true,
        permSendMessages: true,
        permReceiveMessages: true,
        permViewFiles: true,
        permViewFilesWithNoTags: false,
        permUploadFiles: true,
        permRenameFiles: true,
        permAddFileTags: true,
        permRemoveFileTags: false,
        permDeleteFiles: false,
        permReceiveFiles: true,
        permLoadXbrlAnalysis: true,
        permUpdateXbrlAnalysis: false,
        permLoadCrAnalysis: true,
        permUpdateCrAnalysis: false,
        permLoadCrifAnalysis: true,
        permUpdateCrifAnalysis: false,
        tags: [],
        expiration: moment().add(7, 'days'),
      };
      const invitations = [ ...this.value.invitations, newValue ];
      this.propertyChanged('invitations', invitations);
    },

    removeInvitation(index) {
      if (!confirm('Sei sicuro di voler rimuovere questo invito?')) {
        return;
      }

      const invitations = [ ...this.value.invitations ];
      invitations.splice(index, 1);
      this.propertyChanged('invitations', invitations);
    },

    tagsSelected(item, index, tags) {
      const oldTags = sortBy(item.tags.map(t => t.tag.id));
      const newTags = sortBy(tags.map(t => t.id));

      if (!isEqual(oldTags, newTags)) {
        const arr = [ ...this.value.invitations ];
        arr[index] = { ...item };
        arr[index].tags = tags.map(t => ({ userEmail: item.userEmail, tag: t }));
        this.propertyChanged('invitations', arr);
      }
    },
  },
}
</script>
